<template>
  <div class="config-form-content weeduc-admin-config adminWeeducConfig" v-if="hasReady">
    <div class="weeduc-admin-config-section">
      <h3 class="weeduc-admin-config-section-title">Redes sociais</h3>
      <p class="weeduc-admin-config-section-lead">Ative os canais e informe o endereço de cada um.</p>
      <div class="weflix-social-grid">
        <article class="weflix-social-card" v-for="(item, index) in names" :key="index">
          <div class="weflix-social-card__head">
            <span
              class="weflix-social-card__icon"
              :class="[
                'weflix-social-card__icon--' + socialKeys[index],
                { 'weflix-social-card__icon--on': activeSocial[index] },
              ]"
            >
              <fa :icon="['fab', socialIcons[index]]" />
            </span>
            <span class="weflix-social-card__name">{{ item }}</span>
            <div class="form-check form-switch mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="activeSocial[index]"
                :id="'socialSwitch' + index"
              />
            </div>
          </div>
          <input
            type="text"
            class="form-input"
            :placeholder="placeholders[index]"
            v-model="linkSocial[index]"
            :disabled="!activeSocial[index]"
          />
        </article>
      </div>
      <div class="buttons-container weeduc-admin-site-form-actions">
        <div class="button d-flex flex-wrap gap-2 justify-content-end">
          <button type="button" class="btn btn-block btn-content" @click="editSocialMedia">Salvar</button>
        </div>
      </div>
    </div>
  </div>
  <Loader :hasReady="hasReady" />
</template>


<script>
import apiSiteSocialMidia from '@/utils/Weflix/socialMedia';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import { toast } from 'vue3-toastify';

export default {
  data() {
    return {
      hasSaved: false,
      data:[],
      activeSocial: Array(6).fill(false),
      linkSocial: Array(6).fill(''),
      names: ['Facebook', 'Instagram', 'Youtube', 'Linkedin', 'Whatsapp', 'TikTok'],
      socialIcons: ['facebook-f', 'instagram', 'youtube', 'linkedin-in', 'whatsapp', 'tiktok'],
      socialKeys: ['facebook', 'instagram', 'youtube', 'linkedin', 'whatsapp', 'tiktok'],
      placeholders: [
        'facebook.com/suapagina',
        'instagram.com/suapagina',
        'youtube.com/canal',
        'linkedin.com/empresa',
        'whatsapp.com/numero',
        'tiktok.com/@usuario'
      ],
      hasReady: false
    };
  },
  computed: {
    ...mapState(['token']),
  },
  components: {
    Loader,
  },
  methods: {
    fillPreviewData() {
      const samples = [
        'facebook.com/weflix',
        'instagram.com/weflix',
        'youtube.com/@weflix',
        'linkedin.com/company/weflix',
        'wa.me/5521994647568',
        'tiktok.com/@weflix',
      ];
      samples.forEach((url, index) => {
        if (!this.linkSocial[index]) {
          this.linkSocial[index] = url;
          this.activeSocial[index] = true;
        }
      });
    },
    async editSocialMedia() {
      this.hasReady = false;
      const socialData = [];
      const newItems = [];

      this.linkSocial.forEach((link, index) => {
        if(link!==''){
          const id = this.data[index] ? this.data[index].id : null;
          const status = this.activeSocial[index] ? 1 : 0;
          const url = link ? link : null;
          const type = index;
          const name = this.names[index];

          if (id) {
            socialData.push({ id, name, type, url, status });
          } else if (this.activeSocial[index] == 1) {
            newItems.push({ name, type, url, status });
          }
        }
      });

      try {
        if (socialData.length > 0) {
          await apiSiteSocialMidia.editSocialMidias(this.token, socialData);
          this.hasReady = true;
        }

        if (newItems.length > 0) {
          await apiSiteSocialMidia.postSocialMidiastData(this.token, newItems);
          this.hasReady = true;
        }

        this.getDataSocialMedia();
        this.notify('Redes sociais atualizadas com sucesso!', 'success');
      } catch (error) {
        console.error(error);
        this.notify('Erro ao obter dados das redes sociais.', 'error');
      }
    },
  
    async getDataSocialMedia(){
      try {
        const response = await apiSiteSocialMidia.getSocialMidia(this.token);
        this.data = response;
        this.data.forEach((item) => {
          this.activeSocial[item.type] = item.status === 1;
          this.linkSocial[item.type] = item.url;
        });
        this.hasReady = true;
      } catch (error) {
        console.error(error);
      }
    },
    notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
  },
  props: {
    saved: Boolean,
  },
  created() {
    this.getDataSocialMedia();
  },
};
</script>

<style scoped>
@import '@/css/weeduc/admin/config.css';

.weflix-social-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

.weflix-social-card {
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid #e8eaf0;
  background: #fff;
}

.weflix-social-card__head {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.weflix-social-card__icon {
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 2.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f4f5f8;
  color: #98a2b3;
}

.weflix-social-card__icon svg {
  width: 1rem;
  height: 1rem;
  color: inherit;
  fill: currentColor;
}

.weflix-social-card__icon--on.weflix-social-card__icon--facebook { color: #1877f2; background: #e7f1ff; }
.weflix-social-card__icon--on.weflix-social-card__icon--instagram { color: #e4405f; background: #fde8ee; }
.weflix-social-card__icon--on.weflix-social-card__icon--youtube { color: #ff0000; background: #ffe8e8; }
.weflix-social-card__icon--on.weflix-social-card__icon--linkedin { color: #0077b5; background: #e6f4fb; }
.weflix-social-card__icon--on.weflix-social-card__icon--whatsapp { color: #25d366; background: #e7f9ee; }
.weflix-social-card__icon--on.weflix-social-card__icon--tiktok { color: #111111; background: #f3f4f6; }

.weflix-social-card__name {
  flex: 1;
  min-width: 0;
  font-weight: 600;
  color: #1a1d26;
}

.weflix-social-card .form-switch {
  margin-left: auto;
  flex: 0 0 auto;
  min-height: 1.5rem;
  padding-left: 0;
  display: flex;
  align-items: center;
}

.weflix-social-card .form-switch .form-check-input {
  float: none;
  margin: 0;
  width: 2.6rem;
  height: 1.4rem;
  cursor: pointer;
}

.weflix-social-card .form-input {
  display: block;
  width: 100%;
  min-width: 0;
  height: 42px;
  box-sizing: border-box;
  margin: 0;
  padding: 0 12px;
  border: 1px solid #d9dfea;
  border-radius: 8px;
  background: #fff;
  color: #11143d;
  font-size: 13px;
  line-height: 1.3;
}

.weflix-social-card .form-input:focus {
  outline: none;
  border-color: #250891;
  box-shadow: 0 0 0 3px rgba(37, 8, 145, 0.12);
}

.weflix-social-card .form-input:disabled {
  background: #f8f9fd;
  color: #94a3b8;
  border-color: #e7eaf2;
}

.weflix-social-card .form-check-input:checked {
  background-color: #250891;
  border-color: #250891;
}

:global(.dashboard.dark) .weflix-social-card {
  background: #2a2d36;
  border-color: #3d414d;
}

:global(.dashboard.dark) .weflix-social-card__name {
  color: #f1f3f7;
}

:global(.dashboard.dark) .weflix-social-card__icon {
  background: #323643;
  color: #9ca3b4;
}

:global(.dashboard.dark) .weflix-social-card__icon--on.weflix-social-card__icon--tiktok {
  color: #f4f5fb;
  background: #3a3d48;
}

:global(.dashboard.dark) .weflix-social-card .form-input {
  background: #201e26;
  color: #f4f5fb;
  border-color: #3a3a48;
}

:global(.dashboard.dark) .weflix-social-card .form-input:disabled {
  background: #2a2d36;
  color: #9ca3b4;
}

@media (max-width: 700px) {
  .weflix-social-grid {
    grid-template-columns: 1fr;
  }
}
</style>
